<template>
    <div>
        <div v-if="!showTable">
            <loading v-if="!showTable" />
        </div>
        <div v-else>
            <b-form-select
                v-model="nth"
                :options="balanceSteps"
                class="col-4 mb-3"
                size="sm"
                @change="getData"
            />
            <table class="table table-sm text-center">
                <thead>
                    <tr>
                        <th class="text-left">Collaborateur</th>
                        <th width="6%">jan</th>
                        <th width="6%">fév</th>
                        <th width="6%">mar</th>
                        <th width="6%">avr</th>
                        <th width="6%">mai</th>
                        <th width="6%">jun</th>
                        <th width="6%">jul</th>
                        <th width="6%">aou</th>
                        <th width="6%">sep</th>
                        <th width="6%">oct</th>
                        <th width="6%">nov</th>
                        <th width="6%">déc</th>
                        <th width="6%">Total</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="line in lines">
                        <td class="text-left my-border">
                            {{ line.user_name }}
                        </td>
                        <td>{{ formatNumber(line.jan) }}</td>
                        <td>{{ formatNumber(line.feb) }}</td>
                        <td>{{ formatNumber(line.mar) }}</td>
                        <td>{{ formatNumber(line.apr) }}</td>
                        <td>{{ formatNumber(line.may) }}</td>
                        <td>{{ formatNumber(line.jun) }}</td>
                        <td>{{ formatNumber(line.jul) }}</td>
                        <td>{{ formatNumber(line.aug) }}</td>
                        <td>{{ formatNumber(line.sep) }}</td>
                        <td>{{ formatNumber(line.oct) }}</td>
                        <td>{{ formatNumber(line.nov) }}</td>
                        <td>{{ formatNumber(line.dec) }}</td>
                        <td>{{ formatNumber(line.tot) }}</td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <th class="text-left my-border">TOTAL</th>
                        <th>{{ formatNumber(total.jan) }}</th>
                        <th>{{ formatNumber(total.feb) }}</th>
                        <th>{{ formatNumber(total.mar) }}</th>
                        <th>{{ formatNumber(total.apr) }}</th>
                        <th>{{ formatNumber(total.may) }}</th>
                        <th>{{ formatNumber(total.jun) }}</th>
                        <th>{{ formatNumber(total.jul) }}</th>
                        <th>{{ formatNumber(total.aug) }}</th>
                        <th>{{ formatNumber(total.sep) }}</th>
                        <th>{{ formatNumber(total.oct) }}</th>
                        <th>{{ formatNumber(total.nov) }}</th>
                        <th>{{ formatNumber(total.dec) }}</th>
                        <th>{{ formatNumber(total.tot) }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from '../../../common/components/loading'

export default {
    name: 'BalanceState',

    components: {
        loading,
    },

    data() {
        return {
            showTable: false,
            lines: [],
            total: {},
            nth: 1,
        }
    },

    async created() {
        await this.getData()
    },

    methods: {
        initTotal() {
            this.total.jan = 0
            this.total.feb = 0
            this.total.mar = 0
            this.total.apr = 0
            this.total.may = 0
            this.total.jun = 0
            this.total.jul = 0
            this.total.aug = 0
            this.total.sep = 0
            this.total.oct = 0
            this.total.nov = 0
            this.total.dec = 0
            this.total.tot = 0
        },

        async getData() {
            this.showTable = false
            try {
                const response = await axios.get(
                    `/dashboard/balance/${this.year}/state/${this.nth}`
                )
                this.lines = response.data.data
                this.calculateTotal()
                this.showTable = true
            } catch (error) {
                console.log(error)
            }
        },

        calculateTotal() {
            this.initTotal()
            this.lines.forEach((item) => (this.total.jan += item.jan))
            this.lines.forEach((item) => (this.total.feb += item.feb))
            this.lines.forEach((item) => (this.total.mar += item.mar))
            this.lines.forEach((item) => (this.total.apr += item.apr))
            this.lines.forEach((item) => (this.total.may += item.may))
            this.lines.forEach((item) => (this.total.jun += item.jun))
            this.lines.forEach((item) => (this.total.jul += item.jul))
            this.lines.forEach((item) => (this.total.aug += item.aug))
            this.lines.forEach((item) => (this.total.sep += item.sep))
            this.lines.forEach((item) => (this.total.oct += item.oct))
            this.lines.forEach((item) => (this.total.nov += item.nov))
            this.lines.forEach((item) => (this.total.dec += item.dec))
            this.lines.forEach((item) => (this.total.tot += item.tot))
        },

        formatNumber(number) {
            return number === 0 ? '-' : number
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            balanceSteps: (state) => state.data.options.balanceSteps,
        }),
    },
}
</script>

<style scoped></style>
